<template>
  <el-dialog
    title="设置字段归类"
    :visible.sync="dialogVisible"
    append-to-body
    :show-close="false"
    :close-on-click-modal='false'
    :close-on-press-escape="false"
    class="default-dialog c-choiceType-dialog"
    width="800px"
   >
   <div v-loading="loading">
     <div class="c-choiceType-dialog-table">
       <div class="c-choiceType-dialog-table-tip">
         tips：因日记账版本更新，所有字段需设置字段显示规则！
       </div>
       <public-table  :table="tableData">
         <!-- props.scope.row.number -->
       	<template slot='fillRule' slot-scope='props'>
       		<el-radio-group v-model="props.scope.row.fillRule">
            <el-radio :label="0">收支都显示</el-radio>
            <el-radio :label="1">仅收入时显示</el-radio>
            <el-radio :label="2">仅支出时显示</el-radio>
          </el-radio-group>
       	</template>
       </public-table>
     </div>
     <div class="c-choiceType-dialog-btn">
       <accBtn @click="handleSave"></accBtn>
     </div>
   </div>
  </el-dialog>
</template>

<script>
  import publicTable from '@/components/publicTable'
  export default {
    components:{
      publicTable
    },
    data() {
      return {
        dialogVisible:false,
        tableData: {
          Maxheight:"500px",
        	border: true,				// 是否带有纵向边框
        	stripe: true,				// 是否带有斑马纹
        	loading: false,				// 是否显示加载动画
        	hasSelect: false,			// 是否显示多选
        	hasOperation: false,		// 是否有操作功能
        	hasContextmenu: false,		// 是否有右键功能
        	hasShowSummary: false,		// 是否显示合计行
        	hasShowPagination: false,	// 是否显示分页
        	config: [{
        		label: '字段名称',
        		value: 'columnName',
            width:"180",
        		show: 'normal'
        	},{
        		label: '显示规则',
        		value: 'fillRule',
        		show: 'template',
            width:"280",
        	}],
        	data: [],
        	page: {
        		pageNo: 1,
        		pageSize: 20,
        		count: 10
        	},
        	center: {
        		textAlign: 'center',
        		padding: '6px 0'
        	}
        },
        loading:false
      }
    },
    created() {
    },
    watch:{
      dialogVisible(val) {
        if(val) {
          this.getTableData();
        }
      }
    },
    methods:{
      // 保存设置
      handleSave() {
        let data = this.tableData.data;
        let isAllChoice = data.every(i=>{ return i.fillRule|| (i.fillRule===0) });  // 是否都选了
        if(isAllChoice) {
          this.loading = true;
          this.$http.post('custom/batchUpdateCustomColumn',{columnList:data}).then(res=>{
            this.loading = false;
             if(res && res.data.code == 1) {
               this.$message.success("设置成功！")
               this.$emit("saveSuccess",true)
               this.dialogVisible = false;
             }
          })
        }else {
          this.$message.warning("必须每个字段设置显示规则！")
        }
      },
      // 获取所有的项  包括禁用的
      getTableData() {
        this.loading = true;
        this.$http.post('custom/getCustomColumnAll',{}).then(res=>{
          this.loading = false;
           if(res && res.data.code == 1) {
              this.tableData.data = res.data.data;
           }
        })
      }
    }
  }
</script>

<style lang='less' scoped>
  @import "../../../../assets/css/cashierdiary/choiceType-dialog.less";
</style>



// WEBPACK FOOTER //
// src/pages/cashier/components/c-query-table/choiceType.vue